<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center">
      <b-col cols="12" md="4" >
        <font-awesome-icon :icon="['fas', 'check-circle']" class="text-success my-auto success-icon"></font-awesome-icon>
        <h3 class="font-weight-bolder mt-3">Payment Successful!</h3>
        <p class="" style="margin-bottom: 55px">Thank you for donating to {{organization}}</p>
        <a class="btn btn-primary btn-block" :href="getFromApps?'musicverse://transaction_done':'/#/home'" >Continue</a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "DonationsSuccess",
  data() {
    return {
      organization:``,
    }
  },
  async mounted(){
    if(this.donationTrxData!==''){
      this.organization = this.donationTrxData.organization;
      window.fbq('track', 'Subscribe', {
        value: this.donationTrxData.price,
        currency: this.donationTrxData.currency,
        predicted_ltv: this.donationTrxData.price,
        content_category: 'donations',
      })
      this.removePaymentDataDonation();

    }else{
      this.$router.push({ name: 'HomePage' });
    }
  },
  computed:{
    ...mapGetters('PaymentModule', ['donationTrxData']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser','getFromApps']),
  },
  methods:{
    ...mapActions('PaymentModule', ['removePaymentDataDonation','setPaymentError']),
    ...mapActions('AuthModule',['requestDetailUser']),
  },
}
</script>

<style scoped>
.cursor-pointer{
  cursor: pointer;
}
.success-icon{
  font-size: 134px
}
.credit-text{
  font-size: 100px;
}
.copy-icon-link{
  right: -40px;top: 25px;
}
.copy-icon{
  width: 40px; height: 50px; margin:auto
}
.social-item img{
  width: 45px;
}
@media screen and (max-width: 767.98px) {
  .credit-text{
    font-size: 50px;
  }
  .copy-icon-link{
    right: 0;
    top: 12px;
  }
  .copy-icon{
    width: 20px; height: 30px; margin:auto
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DonationsSuccess.vue